import moment from "../../util/momentTimezone";

export const BESS_PARAMS_ENUM = {
  STATE_OF_CHARGE: "SoC",
  STATE_OF_HEALTH: "SoH",
  CHARGE_TOTAL: "Charge_Total",
  DISCHARGE_TOTAL: "Discharge_Total",
  POWER: "Power",
  CURRENT: "Current",
  TEMPERATURE: "Temp",
  VOLTAGE: "Voltage",
  STATUS_CODE: "Status",
  STATUS_MSG: "Status_Message",
  GY_STATUS: "GY_Status"
};

export const get_BESS_col_name = (cabinet_no, bess_param) => {
  const cabinet = !isNaN(parseInt(cabinet_no)) ? cabinet_no.toString().padStart(2, '0') : cabinet_no;
  return `BESS_Cabinet_${cabinet}_${bess_param}`;
}

export const combine_cabinet_data = (row, nb_cabients) => {
  const newRow = { ...row };
  newRow[get_BESS_col_name("ALL", BESS_PARAMS_ENUM.STATE_OF_CHARGE)] = Array(nb_cabients).fill(0).map((_, i) => row[get_BESS_col_name(i + 1, BESS_PARAMS_ENUM.STATE_OF_CHARGE)]).reduce((acc, curr) => acc + curr, 0) / nb_cabients;
  newRow[get_BESS_col_name("ALL", BESS_PARAMS_ENUM.STATE_OF_HEALTH)] = Array(nb_cabients).fill(0).map((_, i) => row[get_BESS_col_name(i + 1, BESS_PARAMS_ENUM.STATE_OF_HEALTH)]).reduce((acc, curr) => acc + curr, 0) / nb_cabients;
  newRow[get_BESS_col_name("ALL", BESS_PARAMS_ENUM.POWER)] = Array(nb_cabients).fill(0).map((_, i) => row[get_BESS_col_name(i + 1, BESS_PARAMS_ENUM.POWER)]).reduce((acc, curr) => acc + curr, 0);
  newRow[get_BESS_col_name("ALL", BESS_PARAMS_ENUM.VOLTAGE)] = Array(nb_cabients).fill(0).map((_, i) => row[get_BESS_col_name(i + 1, BESS_PARAMS_ENUM.VOLTAGE)]).reduce((acc, curr) => acc + curr, 0) / nb_cabients;
  newRow[get_BESS_col_name("ALL", BESS_PARAMS_ENUM.CURRENT)] = Array(nb_cabients).fill(0).map((_, i) => row[get_BESS_col_name(i + 1, BESS_PARAMS_ENUM.CURRENT)]).reduce((acc, curr) => acc + curr, 0) / nb_cabients;
  newRow[get_BESS_col_name("ALL", BESS_PARAMS_ENUM.TEMPERATURE)] = Array(nb_cabients).fill(0).map((_, i) => row[get_BESS_col_name(i + 1, BESS_PARAMS_ENUM.TEMPERATURE)] || 0).reduce((acc, curr) => acc + curr, 0) / nb_cabients;
  return newRow;
}

export const map_daily_data = data => {
  const dailyData = {};
  for(let key of Object.keys(data[0])) {
    dailyData[key] = data.map(row => row[key]);
    if(key === 'dateData') {
      dailyData[key] = dailyData[key].map(dateStr => moment(dateStr).format('DD/MM'));
    }
  }
  return dailyData;
}

export const map_monthly_data = data => {
  const monthlyData = {};
  for(let key of Object.keys(data[0])) {
    monthlyData[key] = data.map(row => row[key]);
    if(key === 'dateData') {
      monthlyData[key] = monthlyData[key].map(dateStr => moment(dateStr).format('MM/YYYY'));
    }
  }
  return monthlyData;
}